import http from './api'

const route = 'app/financeiro/contas-pagar/'

export default {
  showValoresAPagar: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresAPagar', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showValoresPagos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresPagos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showRelacaoValoresPagos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showRelacaoValoresPagos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showValoresAberto: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresAberto', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showRelacaoValoresAbertos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showRelacaoValoresAbertos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showValoresVencidos: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresVencidos', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showRelacaoValoresVencido: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showRelacaoValoresVencido', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showProjecaoContasPagar: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showProjecaoContasPagar', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showValoresAFornecedores: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showValoresAFornecedores', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showJurosPagar: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showJurosPagar', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDescontoPagar: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDescontoPagar', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showPMC: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showPMC', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showPMP: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showPMP', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showContasPagar: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showContasPagar', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showContasAberta: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showContasAberta', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showContasAPagarAnual: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showContasAPagarAnual', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDelhamentoPagar: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosDelhamentoPagar', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDelhamentoPagas: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosDelhamentoPagas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDelhamentoAVencer: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosDelhamentoAVencer', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDelhamentoPagarVencido: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosDelhamentoPagarVencido', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDelhamentoPagarRankingFornecedores: (dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showDadosDelhamentoPagarRankingFornecedores', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },
}
